import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faXmark} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from "react-i18next";

export default function CancelButton({onClick, className, enabled=true}) {
    const { t } = useTranslation();
    return (
        <button
            className={`${className} flex flex-row items-center font-inter rounded-xl bg-playmove-lightred w-28 py-3.5 ${enabled ? "hover:bg-playmove-yellow" : "opacity-25"}`}
            onClick={enabled ? onClick : null}><span className="m-auto flex flex-row items-center gap-x-1"><FontAwesomeIcon className="text-playmove-red" icon={faXmark}/> <span className="text-sm text-playmove-gray ">{t("cancel")}</span></span></button>
    )
}